export function createCssLine(
  dataTarget: string,
  property: string,
  value: string,
  postFix: string = "",
) {
  return `[data-target='${dataTarget}'] {
    ${property}: ${value}${postFix} !important;
  }`;
}
